import { render, staticRenderFns } from "./Produits.vue?vue&type=template&id=ba6dc2e8&scoped=true&"
import script from "./Produits.vue?vue&type=script&lang=js&"
export * from "./Produits.vue?vue&type=script&lang=js&"
import style0 from "./Produits.vue?vue&type=style&index=0&id=ba6dc2e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6dc2e8",
  null
  
)

export default component.exports